import { EnumResolver } from '../../../../commons/enums/enum-resolver.js';

// @lib-export
var ApplicationAppearanceLogoTypeVo;
(function (ApplicationAppearanceLogoTypeVo) {
    ApplicationAppearanceLogoTypeVo["COMPANY_LOGO"] = "COMPANY_LOGO";
    ApplicationAppearanceLogoTypeVo["CUSTOM_LOGO"] = "CUSTOM_LOGO";
    ApplicationAppearanceLogoTypeVo["PORTAL_NAME"] = "PORTAL_NAME";
})(ApplicationAppearanceLogoTypeVo || (ApplicationAppearanceLogoTypeVo = {}));
const APPLICATION_LOGO_TYPE_VO_RESOLVER = new EnumResolver(`ApplicationLogoTypeVo`, Object.entries(ApplicationAppearanceLogoTypeVo));

export { APPLICATION_LOGO_TYPE_VO_RESOLVER, ApplicationAppearanceLogoTypeVo };
//# sourceMappingURL=application-appearance-logo-type-vo.js.map
